import { useMeQuery } from '@generated/graphql';
import { useUnit } from 'effector-react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { $user, $userError, $userLoading, setUser, setUserError, setUserLoading } from './model';

const useMe = (skip = false) => {
  const { i18n } = useTranslation();
  const { data, loading: meLoading, error: meError } = useMeQuery({ skip });
  const [me, loading, error] = useUnit([$user, $userLoading, $userError]);

  useEffect(() => {
    if (skip) {
      return;
    }

    if (data?.me.language && i18n.language !== data?.me.language) {
      i18n.changeLanguage(data?.me.language);
    }
    setUserLoading(meLoading);
    setUserError(meError || null);
    setUser(meLoading || meError ? null : data?.me || null);
  }, [data, i18n, meError, meLoading, skip]);

  if (skip) {
    return {
      me: null,
      loading: false,
      error: null,
    };
  }

  return {
    me,
    loading,
    error,
  };
};

export default useMe;
